// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1d1aea0a","977":"b6182d9e"}[chunkId] + ".chunk.js";
};